import React from 'react';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../Store';
import Layout from '../components/layouts/Layout';
import SEO from '../components/seo';

import hero from '../components/prizes/hero.png';

import '../components/prizes/style.scss';

import prizescopy from '../components/prizes/copy.js';
import MarkdownArea from '../components/widgets/markdown_area_plus';

export const Prizes = ({ user, notification, actions }) => {
    return (
        <Layout user={user} notification={notification} actions={actions}>
            <SEO title="Prizes" />
            <PrizesInner />
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Prizes);

export const PrizesInner = () => {
    return (
        <div className="prizes">
            <div className="upper-content">
                <img
                    className="img-responsive center-block"
                    src={hero}
                    alt="Win a Trip To Las Vegas"
                />
            </div>
            <div className="inner-content">
                <div className="copy-text">
                    <MarkdownArea>{prizescopy.copy}</MarkdownArea>
                </div>
            </div>
        </div>
    );
};
